/** Catalog (reference data) API calls. All public reads. */
import { apiFetch } from './apiClient';

const qs = (params = {}) => {
  const s = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();
  return s ? `?${s}` : '';
};

export const getStates = () => apiFetch('/api/catalog/states', { auth: false });
export const getMarkets = (params) => apiFetch(`/api/catalog/markets${qs(params)}`, { auth: false });
export const getCategories = () => apiFetch('/api/catalog/categories', { auth: false });
export const getCommodities = (params) => apiFetch(`/api/catalog/commodities${qs(params)}`, { auth: false });
// Aggregated per-commodity coverage from local uploads: { [id]: { records, markets,
// bagSizes, priceMin, priceMax, pricePerKg, latestDate } }. Powers the public per-kg figure.
export const getCommodityCoverage = () => apiFetch('/api/catalog/commodities/coverage', { auth: false });

// Per-market summary from uploaded prices: { [marketId]: { records, commodities,
// latestDate } }. Markets with no uploads are absent, which is how the admin
// page tells a market that is being surveyed from one that only exists on paper.
export const getMarketCoverage = () => apiFetch('/api/catalog/markets/coverage', { auth: false });
export const getAliases = (commodityId) =>
  apiFetch(`/api/catalog/aliases${qs({ commodityId })}`, { auth: false });
export const getGlobalCommodities = () => apiFetch('/api/catalog/global-commodities', { auth: false });
export const getGlobalSpecies = () => apiFetch('/api/catalog/global-species', { auth: false });
